// extracted by mini-css-extract-plugin
export default {"block":"info_block__bJNIX","block2":"info_block2__9CU44","block3":"info_block3__H2R-F"};